import FashionPreorderDevelopmentBreakdown from "~/components/demand-2/demand/FashionPreorderDevelopmentBreakdown"
import PreorderDevelopmentBreakdown from "~/components/demand-2/demand/PreorderDevelopmentBreakdown"
import type { PreorderInsight } from "~/components/demand-2/shared/preorderDevelopment"

/**
 * "Pre-order development" for the plan's kind: NOOS compares the book against 52 weeks ago;
 * fashion, with no trailing year, against the accepted comparables' pre-orders. One component so
 * callers don't each branch on kind.
 */
const PreorderBreakdown = ({ persistKey, data }: { persistKey: string; data: PreorderInsight }) =>
  data.kind === "fashion" ? (
    <FashionPreorderDevelopmentBreakdown persistKey={persistKey} data={data} />
  ) : (
    <PreorderDevelopmentBreakdown persistKey={persistKey} data={data} />
  )

export default PreorderBreakdown
